import { z } from 'zod'

const sidebarCollapseCookieSchema = z.coerce.boolean().default(false)

export default defineNuxtPlugin({
  name: 'sidebar-states',
  enforce: 'pre',
  setup() {
    // Sidebar Navigation
    const sidebarCollapseCookie = useCookie('kiso:sidebar-collapsed')
    const sidebarCollapsed = ref(sidebarCollapseCookieSchema.parse(sidebarCollapseCookie.value))
    const sidebarForcedCollapsed = ref(false)
    watch(sidebarCollapsed, () => {
      sidebarCollapseCookie.value = String(sidebarCollapsed.value)
    })

    return {
      provide: {
        sidebarCollapsed,
        sidebarForcedCollapsed,
      },
    }
  },
})
